// extracted by css-extract-rspack-plugin
export default {"area":"OYuUNrum8Gg1rLG2","primary":"wjmatUwS5zU5rvM4","utility":"tEZaVZ4fQQmpsNDR","mobile":"hoSUoRf2UJQAcIcj"};